import React, { PropsWithChildren, ReactNode } from 'react'

const ConditionalWrapper: React.FC<
    PropsWithChildren<{
        condition: boolean
        wrapper: (children: ReactNode) => JSX.Element
    }>
> = ({ condition, wrapper, children }) => (condition ? wrapper(children) : <>{children}</>)

export default ConditionalWrapper
